module.exports = __webpack_public_path__ + "media/src/images/logo_media-e8fb9b855b13d335352eb9c9a74888ba.svg";